import { render, staticRenderFns } from "./MapPaletteSelector.vue?vue&type=template&id=53cd579e&scoped=true&lang=html&"
import script from "./MapPaletteSelector.vue?vue&type=script&lang=js&"
export * from "./MapPaletteSelector.vue?vue&type=script&lang=js&"
import style0 from "./MapPaletteSelector.vue?vue&type=style&index=0&id=53cd579e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cd579e",
  null
  
)

export default component.exports